/* eslint-disable @typescript-eslint/no-explicit-any */
import axios from 'axios';

import { BASE_ENDPOINT } from '../constant';

export interface newsListingProps {
  pageSize?: number;
  page?: number;
  locale?: string;
  postCategory?: string;
  subCategory?: string;
  author?: string;
  keyword?: string;
  tag?: string;
  brand?: string;
  latest?: boolean;
  model?: string;
  isPinned?: boolean;
}

export const getNewsListing = async (props: newsListingProps): Promise<any> => {
  const { pageSize = 80, page = 1, locale = 'en' } = props;
  const baseUrl =
    props?.keyword || props?.tag
      ? `${BASE_ENDPOINT}/post`
      : `${BASE_ENDPOINT}/post_category`;

  const url =
    baseUrl +
    (props?.keyword ? `/search/${props?.keyword}` : '') +
    (props?.latest ? `/latest` : '') +
    (props?.tag ? `/tag/${props?.tag}` : '') +
    (props?.brand ? `/latest` : '') +
    (props?.postCategory ? `/${props?.postCategory}` : '') +
    `?per_page=${pageSize}&page=${page}&locale=${locale}` +
    (props?.subCategory ? `&post_category_item=${props?.subCategory}` : '') +
    (props?.author ? `&author=${props?.author}` : '') +
    (props?.brand ? `&car_brand=${props?.brand}` : '') +
    (props?.model ? `&car_model=${props?.model}` : '') +
    (props?.isPinned ? `&is_pinned=1` : '');

  try {
    const config = {
      method: 'get',
      url: url,
    };
    const response = await axios.request(config);

    return response.data;
  } catch (error) {
    console.log('Fetch Error:', error);
    return {};
  }
};

export default getNewsListing;
